import { render } from "./itemsbestbuyprods.vue?vue&type=template&id=1f02b5f2"
import script from "./itemsbestbuyprods.vue?vue&type=script&lang=js"
export * from "./itemsbestbuyprods.vue?vue&type=script&lang=js"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__